import React from 'react';
import { milestones, volumes } from '../data/salesPage';
import type { Volume } from '../data/salesPage';
export function VolumesSection() {
  return <section aria-labelledby="volumenes" className="bg-ink" data-id="element-216" data-mp="3uw8b2no9ardb">
      <div className="mx-auto max-w-5xl px-5 py-20 sm:py-28" data-id="element-217" data-mp="cng6qt695tdp">
        <p className="font-display text-sm font-bold uppercase tracking-[0.25em] text-lime" data-id="element-218" data-mp="7pejrx5ph9wy">¿Qué vas a encontrar?</p>
        <h2 id="volumenes" className="mt-4 font-display text-5xl font-black uppercase leading-none text-bone sm:text-7xl" data-id="element-219" data-mp="3g4pzd22fjizr">
          6 volúmenes completos
        </h2>

        <div className="mt-14 divide-y divide-ink-line border-y border-ink-line" data-id="element-220" data-mp="3c1tbavu4euof">
          {volumes.map(volume => volume.number === 4 ? <CoreVolume key={volume.number} volume={volume} data-id="element-221" data-mp="3l42mzp14ku3e" /> : <VolumeRow key={volume.number} volume={volume} data-id="element-222" data-mp="3l2hq3src8z2d" />)}
        </div>
      </div>
    </section>;
}
function VolumeRow({
  volume
}: {
  volume: Volume;
}) {
  return <article className="grid gap-6 py-12 md:grid-cols-[180px_1fr] md:gap-10" data-id="element-223" data-mp="2sfdh7cp4k0lb">
      <VolumeLabel number={volume.number} data-id="element-224" data-mp="29epfuf096kxp" />
      <div data-id="element-225" data-mp="29dnyxtwk3482">
        <h3 className="font-display text-3xl font-black uppercase leading-tight text-bone sm:text-4xl" data-id="element-226" data-mp="2eebr4iwitr3v">{volume.title}</h3>
        <p className="mt-4 text-lg text-bone-muted" data-id="element-227" data-mp="2j51wvx8uzvz3">{volume.intro}</p>
        <ul className="mt-5 flex flex-wrap gap-2" data-id="element-228" data-mp="2o4erj45z27c8">
          {volume.topics.map(topic => <li key={topic} className="rounded-full border border-ink-line bg-ink-raised px-3.5 py-1.5 text-sm font-medium text-bone" data-id="element-229" data-mp="1qgmklih43rrg">
              {topic}
            </li>)}
        </ul>
        <p className="mt-6 font-display text-xl font-bold text-lime" data-id="element-230" data-mp="20etx9p4dbnnn">{volume.closing}</p>
      </div>
    </article>;
}
function CoreVolume({
  volume
}: {
  volume: Volume;
}) {
  return <article className="my-6 rounded-3xl border border-lime/40 bg-ink-raised p-7 sm:p-10" data-id="element-231" data-mp="24eb70uqtv6ym">
      <div className="grid gap-6 md:grid-cols-[180px_1fr] md:gap-10" data-id="element-232" data-mp="3bw22udqr39te">
        <VolumeLabel number={volume.number} data-id="element-233" data-mp="3fu9hn31nm11y" />
        <div data-id="element-234" data-mp="1gqsxcwl0o1zg">
          <h3 className="font-display text-3xl font-black uppercase leading-tight text-bone sm:text-4xl" data-id="element-235" data-mp="1gqkl96wpx0pb">{volume.title}</h3>
          <p className="mt-4 max-w-2xl text-lg leading-relaxed text-bone-muted" data-id="element-236" data-mp="1bqog34cab386">{volume.intro}</p>
        </div>
      </div>

      <ol className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-ink-line bg-ink-line sm:grid-cols-4 lg:grid-cols-7" data-id="element-237" data-mp="1pqz9of4zavx1">
        {milestones.map(m => {
        const isEdge = m.day === 1 || m.day === 45;
        return <li key={m.day} className={`flex flex-col p-4 ${isEdge ? 'bg-lime text-ink' : 'bg-ink text-bone'}`} data-id="element-238" data-mp="t1rwbueijt47">
              <span className={`text-xs font-bold uppercase tracking-widest ${isEdge ? 'text-ink/70' : 'text-bone-dim'}`} data-id="element-239" data-mp="16swrokaulz8q">Día</span>
              <span className="font-display text-4xl font-black leading-none" data-id="element-240" data-mp="120lon8kt9xby">{m.day}</span>
              <span className={`mt-3 text-sm font-medium ${isEdge ? 'text-ink' : 'text-bone-muted'}`} data-id="element-241" data-mp="earewzvsgovx">{m.label}</span>
            </li>;
      })}
      </ol>

      <p className="mt-8 font-display text-2xl font-black uppercase text-lime" data-id="element-242" data-mp="2l0ckc937ai9x">{volume.closing}</p>
    </article>;
}
function VolumeLabel({
  number
}: {
  number: number;
}) {
  return <div className="flex items-baseline gap-3 md:flex-col md:gap-0" data-id="element-243" data-mp="2c06bj0ig66h3">
      <span className="text-xs font-bold uppercase tracking-[0.25em] text-bone-dim" data-id="element-244" data-mp="2bxtls16g6rth">Volumen</span>
      <span className="font-display text-6xl font-black leading-none text-lime md:text-8xl" data-id="element-245" data-mp="2gwwrzoy5z431">{number}</span>
    </div>;
}